<template>
  <div>
    <ValidationProvider :rules="rules" v-slot="validationContext">
      <b-form-group class="pb-3" :disabled="disabled">
        <template v-slot:label>
          <span v-html="formattedLabel"></span>
        </template>
        <b-form-radio-group
          v-model="input"
          class="horizondal-radiogroup-btn"
          :options="options"
          buttons
          :state="getValidationState(validationContext)"
          @change="$emit('input', input)"
          button-variant="outline-primary"
          name="radio-btn-outline"
        >
          <b-form-invalid-feedback
            :state="getValidationState(validationContext)"
            >{{ message(validationContext) }}</b-form-invalid-feedback
          >
        </b-form-radio-group>
        <slot name="bottom"></slot>
      </b-form-group>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    label: String,
    options: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      input: "",
    };
  },
  computed: {
    formattedLabel() {
      if(!this.rules) return this.label;
      if (this.rules.indexOf("required") != -1)
        return this.label + " <span style='color:red'>*</span>";
      return this.label;
    },
  },
  methods: {
    message(validationContext) {
      return validationContext.errors[0];
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
  mounted() {
    if (this.value != undefined) {
      this.input = this.value.toString();
    }
  },
};
</script>

<style lang="scss">
.horizondal-radiogroup-btn {
  display: block;
  .custom-radio {
    margin-right: 10px;
    float: left;
    .custom-control-label {
      margin-left: 10px;
    }
  }
  .btn {
    width: auto;
  }
  .btn {
    border-radius: 0px !important;
  }
  input {
    display: none;
  }
  .invalid-feedback {
    width: 100%;
    float: left;
  }
}
</style>
